import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";
import { CargoDropDown } from "../../../../../common/domain/models/cargo_dropdown";
import { CentroCustoDropDown } from "../../../../../common/domain/models/centro_custo_dropdown";
import { FuncionarioTercDropDown } from "../../../../../common/domain/models/funcionario_terc_dropdown";

/**
 * useAvaliacaoTreinamentoLoteCadastroFilters
 */

type State = {
  selectedIdCargo: number | null,
  cargos: CargoDropDown[] | null,
  selectedIdFuncionario: number | null,
  funcionarios: FuncionarioTercDropDown[] | null,
  selectedIdCentroCusto: number[] | null,
  centroCustos: CentroCustoDropDown[] | null,
  vencimentoDe: Date | null,
  vencimentoAte: Date | null,
};

type Actions = {
  setSelectedIdCargo: SetFunction<number | null>,
  setSelectedIdFuncionario: SetFunction<number | null>,
  setSelectedIdCentroCusto: SetFunction<number[] | null>,
  setVencimentoDe: SetFunction<Date | null>,
  setVencimentoAte: SetFunction<Date | null>,
  setCargos: SetFunction<CargoDropDown[]>,
  setFuncionarios: SetFunction<FuncionarioTercDropDown[]>,
  setCentroCustos: SetFunction<CentroCustoDropDown[]>,
  clear: () => void,
};

export const useAvaliacaoTreinamentoLoteTercCadastroFilters = create<State & Actions>((set) => ({
  selectedIdCargo: null,
  cargos: null,
  selectedIdFuncionario: null,
  funcionarios: null,
  selectedIdCentroCusto: null,
  centroCustos: null,
  vencimentoDe: null,
  vencimentoAte: null,
  setSelectedIdCargo: vfn => SetFunctionImpl(set, 'selectedIdCargo', vfn),
  setSelectedIdFuncionario: vfn => SetFunctionImpl(set, 'selectedIdFuncionario', vfn),
  setSelectedIdCentroCusto: vfn => SetFunctionImpl(set, 'selectedIdCentroCusto', vfn),
  setVencimentoDe: vfn => SetFunctionImpl(set, 'vencimentoDe', vfn),
  setVencimentoAte: vfn => SetFunctionImpl(set, 'vencimentoAte', vfn),
  setCargos: vfn => SetFunctionImpl(set, 'cargos', vfn),
  setFuncionarios: vfn => SetFunctionImpl(set, 'funcionarios', vfn),
  setCentroCustos: vfn => SetFunctionImpl(set, 'centroCustos', vfn),
  clear: () => set({
    selectedIdCargo: null,
    selectedIdFuncionario: null,
    selectedIdCentroCusto: null,
    vencimentoDe: null,
    vencimentoAte: null,
  }),
}));

